import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles( () => ( {
	// Same pentagon shape as the AI page badge, sized to sit inline with
	// text instead of standing alone. Two sizes for the two font sizes
	// these badges appear next to (the 30px intro lines vs the 24px body
	// paragraph).
	pentagonBadgeLarge: {
		clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
		width: '88px',
		height: '83px',
		fontSize: '28px',
		margin: '0 3px',
		boxSizing: 'border-box',
		// Nudges the label down to the pentagon's visual centroid, which
		// sits below its geometric center for a point-up shape.
		paddingTop: '10px'
	},
	pentagonBadgeSmall: {
		clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)',
		width: '70px',
		height: '66px',
		fontSize: '22px',
		margin: '0 3px',
		boxSizing: 'border-box',
		paddingTop: '8px'
	},
} ) )
